module.exports = __webpack_public_path__ + "static/media/jaemin-5.jpeg";